import { sendNetcore } from '@/functions/tracker/netcore'
import ProgramActivityAPI from '@/api/program-activity'
import { mapState } from 'vuex'
import { swalFire } from '@/functions/swalHelper'

export default {
  data () {
    return {
      faceRecognitionWindow: null
    }
  },
  computed: {
    ...mapState('storage', ['accessToken']),
    ...mapState('user', ['userInfo']),
    ...mapState('analytics', ['source']),
    ...mapState('activityV2', ['activityDashboard']),
    showPrakerjaFaceRecognition: {
      get () {
        return this.$store.state.activityV2.showPrakerjaFaceRecognition
      },
      set (value) {
        this.$store.commit('activityV2/TOGGLE_SHOW_PRAKERJA_FACE_RECOGNITION', value)
      }
    },
    isLoadingFaceRecognition: {
      get () {
        return this.$store.state.activityV2.isLoadingFaceRecognition
      },
      set (value) {
        this.$store.commit('activityV2/TOGGLE_LOADING_FACE_RECOGNITION', value)
      }
    }
  },
  methods: {
    handlePrakerjaFaceRecognition (generateUrl, isFromSessionActivity = false) {
      if (!isFromSessionActivity) this.showPrakerjaFaceRecognition = true
      this.isLoadingFaceRecognition = true
      try {
        const windowFeatures = [
          `width=${window.screen.width}`,
          `height=${window.screen.height}`,
          'top=0',
          'left=0'
        ].join(',')
        // HARFI: comment 3 line of codes below when deploy
        // const parser = document.createElement('a')
        // parser.href = generateUrl
        // const popupWindow = window.open(`http://localhost:8080${parser.pathname}${parser.search}`, 'Prakerja', windowFeatures)
        const popupWindow = window.open(generateUrl, 'Prakerja', windowFeatures)
        if (!popupWindow) {
          // ! If the browser blocked the pop up
          this.showAllowPopUpReminder()
          return
        }
        this.faceRecognitionWindow = popupWindow
        window.prakerjaWindow = {
          window: popupWindow,
          closed: false
        }
        const checkWindowClosed = setInterval(() => {
          // ! If the window is closed manually
          if (popupWindow.closed) {
            clearInterval(checkWindowClosed)
            // * commented for now
            // if (!isFromSessionActivity) this.$store.commit('activityV2/TOGGLE_REDEEM_CODE_MODAL', true)
            window.prakerjaWindow = null
            window.location.reload()
            this.cleanupFaceRecognition()
          }
        }, 500)
        window.addEventListener('message', this.handlePostMessage, false)
      } catch (e) {
        console.error('Error:', e)
        this.isLoadingFaceRecognition = false
      }
    },
    handlePostMessage (event) {
      // HARYO: comment 1 line of codes below when deploy (for local testing)
      // const allowedOrigins = 'http://localhost:8080'
      const allowedOrigins = process.env.VUE_APP_URL_REWRITE_PRAKERJA
      const urlProgramLocation = window.location.pathname
      try {
        if (allowedOrigins !== event.origin) return
        const data = JSON.parse(JSON.stringify(
          typeof event.data === 'string' ? JSON.parse(event.data) : event.data
        ))
        if (data.type === 'prakerja_face_recognition') {
          const baseQuery = {
            state: data.state,
            'url-program': urlProgramLocation
          }

          const query = data.error
            ? {
              ...baseQuery,
              success: data.success,
              error: data.error,
              error_code: data.error_code,
              error_description: data.error_description
            }
            : {
              ...baseQuery,
              success: data.success
            }

          this.$router.push({
            path: '/face-recognition-result',
            query
          })

          if (window.prakerjaWindow?.window) {
            window.prakerjaWindow.window.close()
          }
        }
      } catch (e) {
        console.error('Error:', e)
      } finally {
        this.cleanupFaceRecognition()
      }
    },
    cleanupFaceRecognition () {
      if (this.faceRecognitionWindow) {
        try {
          this.faceRecognitionWindow.close()
        } catch (e) {
          console.error('Error closing window:', e)
        }
        this.faceRecognitionWindow = null
      }
      // Set null to clear any remaining references & delete from window to prevent global pollution
      window.prakerjaWindow = null
      delete window.prakerjaWindow
      window.removeEventListener('message', this.handlePostMessage, false)
      this.isLoadingFaceRecognition = false
      this.showPrakerjaFaceRecognition = false
    },
    async getActivityValidate () {
      const { data } = await ProgramActivityAPI.validateActivity({
        Authorization: this.authorization,
        data: {
          type_access: 'activity',
          user_id: this.userId,
          slug: this.currentActivitySlug
        }
      })

      return data.data
    },
    openFaqAllowPopUp () {
      window.open('https://www.karier.mu/faq/docs/prakerja/program/apa-yang-harus-saya-lakukan-jika-terdapat-pop-up-blocker-setelah-menggunakan-kode-redeem/', '_blank')
      this.$store.commit('activityV2/TOGGLE_LOADING_FACE_RECOGNITION', false)
    },
    async showAllowPopUpReminder () {
      const result = await swalFire({
        imageUrl: 'https://cdn.karier.mu/dashboard-kariermu/assets/illustration/empty-state/access-denied.webp',
        imageWidth: 192,
        title: 'Tidak Dapat Melanjutkan Proses Redeem',
        message: 'Untuk melanjutkan proses redeem, Anda harus <strong>mengizinkan</strong><br/>' +
          'halaman Karier.mu untuk dapat menampilkan <strong>pop-up.</strong>',
        confirmButtonText: 'Mengerti',
        allowOutsideClick: false,
        showCancelButton: true,
        cancelButtonText: 'Lihat Panduan',
        customClass: {
          confirmButton: 'submit-button-allow-popup-reminder',
          cancelButton: 'open-guide-button-allow-popup-reminder'
        }
      })
      try {
        const { data } = await ProgramActivityAPI.getSessionCompletion({
          Authorization: this.accessToken,
          programId: Number(this.programId),
          session: 1
        })

        if (data.status === 200) {
          const { user_activity_id, finished_at, enrolled_at } = data.data
          const payload = {
            user_id: this.userId,
            activity_id: this.$route.params?.aid || user_activity_id || 'NA',
            sequence: 1,
            program_id: this.programId || 'NA',
            page_referrer: window.location.href,
            kelompok_id: this.$route.params?.gid || 'NA',
            program_last_access: finished_at || enrolled_at,
            source: this.source
          }
          if (result.isConfirmed) {
            window.firebaseAnalytics.logEvent('activity_pop_up_mengerti_click', payload)
            sendNetcore('activity_pop_up_mengerti_click', this.userInfo, payload)
          } else if (result.isDismissed) {
            window.firebaseAnalytics.logEvent('activity_pop_up_lihat_panduan_click', payload)
            sendNetcore('activity_pop_up_lihat_panduan_click', this.userInfo, payload)
          }
        } else {
          throw data
        }
      } catch (error) {
        console.error(error)
      } finally {
        if (result.isConfirmed) {
          this.$store.commit('activityV2/TOGGLE_LOADING_FACE_RECOGNITION', false)
        } else if (result.isDismissed) {
          this.openFaqAllowPopUp()
        }
      }
    }
  },
  beforeUnmount () {
    this.cleanupFaceRecognition()
  }
}
